import React from 'react';

const SplashLoader = () => {
  return (
    <div className="flex items-center justify-center py-24">
      <div className="flex flex-col items-center">
        <div className="h-12 w-12 rounded-full border-4 border-[#526bb1] border-t-transparent animate-spin" />
        <p className="mt-4 text-sm text-gray-600">Loading documents…</p>
      </div>
    </div>
  );
};

export default SplashLoader;
